import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { displayWarningToast } from "./../overflowNotification";
import { API_PDC_URL_V2, API_PDC_URL_V1, TSPAY_GATEWAY_URL, API_PDC_URL_V3 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";

export const tspayConstants = {
  LOAD_TSPAY_ACCOUNTS_START: "LOAD_TSPAY_ACCOUNTS_START",
  LOAD_TSPAY_ACCOUNTS_SUCCESS: "LOAD_TSPAY_ACCOUNTS_SUCCESS",
  LOAD_TSPAY_ACCOUNTS_ERROR: "LOAD_TSPAY_ACCOUNTS_ERROR",

  LOAD_TSPAY_LINKED_ACCOUNTS_START: "LOAD_TSPAY_LINKED_ACCOUNTS_START",
  LOAD_TSPAY_LINKED_ACCOUNTS_SUCCESS: "LOAD_TSPAY_LINKED_ACCOUNTS_SUCCESS",
  LOAD_TSPAY_LINKED_ACCOUNTS_ERROR: "LOAD_TSPAY_LINKED_ACCOUNTS_ERROR",

  LOAD_TSPAY_LINK_START: "LOAD_TSPAY_LINK_START",
  LOAD_TSPAY_LINK_SUCCESS: "LOAD_TSPAY_LINK_SUCCESS",
  LOAD_TSPAY_LINK_ERROR: "LOAD_TSPAY_LINK_ERROR",

  LOAD_TSPAY_CONFIG_START: "LOAD_TSPAY_CONFIG_START",
  LOAD_TSPAY_CONFIG_SUCCESS: "LOAD_TSPAY_CONFIG_SUCCESS",
  LOAD_TSPAY_CONFIG_ERROR: "LOAD_TSPAY_CONFIG_ERROR",

  REGISTER_TSPAY_PAYMENT_START: "REGISTER_TSPAY_PAYMENT_START",
  REGISTER_TSPAY_PAYMENT_SUCCESS: "REGISTER_TSPAY_PAYMENT_SUCCESS",
  REGISTER_TSPAY_PAYMENT_ERROR: "REGISTER_TSPAY_PAYMENT_ERROR",

  LOAD_RENEW_CONSENT_START: "LOAD_RENEW_CONSENT_START",
  LOAD_RENEW_CONSENT_SUCCESS: "LOAD_RENEW_CONSENT_SUCCESS",
  LOAD_RENEW_CONSENT_ERROR: "LOAD_RENEW_CONSENT_ERROR",

  REFRESH_TSPAY_ACCOUNT_START: "REFRESH_TSPAY_ACCOUNT_START",
  REFRESH_TSPAY_ACCOUNT_SUCCESS: "REFRESH_TSPAY_ACCOUNT_SUCCESS",
  REFRESH_TSPAY_ACCOUNT_ERROR: "REFRESH_TSPAY_ACCOUNT_ERROR",

  SUGGEST_TSPAY_IBAN_START: "SUGGEST_TSPAY_IBAN_START",
  SUGGEST_TSPAY_IBAN_SUCCESS: "SUGGEST_TSPAY_IBAN_SUCCESS",
  SUGGEST_TSPAY_IBAN_ERROR: "SUGGEST_TSPAY_IBAN_ERROR"
};

export function loadConfig(
  auth, accountantUuid, companyUuid
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: tspayConstants.LOAD_TSPAY_CONFIG_START
      });

      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/pay/configs?itemId=${companyUuid}&managerId=${accountantUuid}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false, ["401"]
      )
        .then((result) => {
          dispatch({
            type: tspayConstants.LOAD_TSPAY_CONFIG_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: tspayConstants.LOAD_TSPAY_CONFIG_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function loadAccounts(
  auth, accountantUuid, companyUuid
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: tspayConstants.LOAD_TSPAY_ACCOUNTS_START
      });

      let request = {
        method: "get",
        url: `${API_PDC_URL_V1}/pay/accounts?itemId=${companyUuid}&managerId=${accountantUuid}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false, ["401"]
      )
        .then((result) => {
          dispatch({
            type: tspayConstants.LOAD_TSPAY_ACCOUNTS_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: tspayConstants.LOAD_TSPAY_ACCOUNTS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function refreshAccount(
  auth, accountantUuid, companyUuid, accountId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: tspayConstants.REFRESH_TSPAY_ACCOUNT_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V1}/pay/accounts/refresh`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          managerId: accountantUuid,
          itemId: companyUuid,
          accountId: accountId,
          psuIpAddress: "127.0.0.1" /* `${
            window.location.origin
              .replace("localhost", "127.0.0.1")
              .replace("http://", "")
              .replace("https://", "")
              .split(":")[0]
          }`*/
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: tspayConstants.REFRESH_TSPAY_ACCOUNT_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: tspayConstants.REFRESH_TSPAY_ACCOUNT_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function renewConsent(
  auth, companyUuid, consentId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: tspayConstants.LOAD_RENEW_CONSENT_START
      });

      let request = {
        method: "put",
        url: `${TSPAY_GATEWAY_URL}/${companyUuid}/consents/${consentId}/renew`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false, ["401"]
      )
        .then((result) => {
          dispatch({
            type: tspayConstants.LOAD_RENEW_CONSENT_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: tspayConstants.LOAD_RENEW_CONSENT_ERROR,
            payload: response.toString()
          });
          displayWarningToast("Non è possibile effettuare il rinnovo per un errore imprevisto. Riprova più tardi.")(dispatch);
          reject();
        });
    });
  };
}

export function registerTSPayPayment(
  auth, accountantUuid, companyUuid, debitor, creditor, deadlinesId, transactionUuid, remittanceInformations
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: tspayConstants.REGISTER_TSPAY_PAYMENT_START,
        payload: deadlinesId
      });

      let request = {
        method: "post",
        url: `${API_PDC_URL_V2}/deadlines/pay`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          itemId: companyUuid,
          managerId: accountantUuid,
          deadlineIds: deadlinesId,
          iban: debitor.iban,
          creditorIban: creditor.iban,
          creditorName: creditor.name,
          remittanceInformations: remittanceInformations,
          redirectUrl: `${window.location.origin.replace("localhost", "127.0.0.1")}${
            window.location.pathname
          }#/tspaycompleted?transactionUuid=${transactionUuid}`
        }
      };

      // mockato
      /* setTimeout(() => {
        dispatch({
          type: tspayConstants.REGISTER_TSPAY_PAYMENT_SUCCESS,
          payload: deadlinesId
        });
        resolve(deadlinesId);
      }, 1500);*/

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: tspayConstants.REGISTER_TSPAY_PAYMENT_SUCCESS,
            payload: { ...result.data, deadlines: [deadlinesId] }
          });
          resolve({ ...result.data, deadlines: [deadlinesId] });
        })
        .catch((err) => {
          dispatch({
            type: tspayConstants.REGISTER_TSPAY_PAYMENT_ERROR,
            payload: err.toString()
          });
          reject(err);
        });
    });
  };
}

export function getTSPayLink(
  auth, itemUuId, managerUuId, deadlinesId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: tspayConstants.LOAD_TSPAY_LINK_START
      });

      let request = {
        method: "post",
        url: `${API_PDC_URL_V2}/deadlines/linkToPay`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          itemId: itemUuId,
          managerId: managerUuId,
          deadlineIds: deadlinesId
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false, ["401"]
      )
        .then((result) => {
          dispatch({
            type: tspayConstants.LOAD_TSPAY_LINK_SUCCESS,
            payload: result.data
          });
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: tspayConstants.LOAD_TSPAY_LINK_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function suggestIbanFromDeadlines(
  auth, accountantUuid, companyUuid, deadlines
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: tspayConstants.SUGGEST_TSPAY_IBAN_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V3}/deadlines/suggestions/iban?itemId=${companyUuid}&accountantId=${accountantUuid}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: deadlines
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: tspayConstants.SUGGEST_TSPAY_IBAN_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: tspayConstants.SUGGEST_TSPAY_IBAN_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
